<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import AmenityMap from './components/amenities/Map';
  import Community from './components/journey/Community';

  export default {
    name: 'app',
    components: {
      'app-map': AmenityMap,
      'app-community': Community
    },
    data() {
      return {

      }
    }
  }
</script>

<style lang="scss">
  @font-face {
    font-family: 'Gotham Book';
    src: url('assets/fonts/Gotham-Book.otf');
    font-weight: normal;
  }

  @font-face {
    font-family: 'Gotham Book';
    src: url('assets/fonts/Gotham-Medium.otf');
    font-weight: 500;
  }

  @font-face {
    font-family: 'Gotham-Medium';
    src: url("assets/fonts/Gotham-Medium.otf");
    font-weight: 500;
  }

  @font-face {
    font-family: 'Gotham Medium';
    src: url("assets/fonts/Gotham-Medium.otf");
    font-weight: 500;
  }

  @font-face {
    font-family: 'Gotham-Bold';
    src: url('assets/fonts/Gotham-Medium.otf');
    font-weight: 700;
  }

  @font-face {
    font-family: 'Gotham Bold';
    src: url('assets/fonts/Gotham-Medium.otf');
    font-weight: 700;
  }
  @import "assets/scss/styles";
</style>



// WEBPACK FOOTER //
// src/App.vue